@if (entry.base?.display) {
  <div class='validate-container mat-typography'>
    @if (!isValid) {
      <div class='form-group'>
        @if (!isLoading) {
          <button (click)="validateMedicareInfo()" mat-raised-button color="primary" class="primary-btn" [disabled]="!isDataAvailableAndValid()">Validate Medicare Information</button>
        }
        @if (isLoading) {
          <mat-spinner [diameter]="25"></mat-spinner>
        }
        @if (!hasAttemptedValidation && formControls[entry.formControlAttributes.formControlName].touched) {
          <mat-error>
            You must validate your medicare information before proceeding to the next page.
          </mat-error>
        }
      </div>
    }
    @if (isValid) {
      <div class='form-group'>
        <button mat-raised-button color="primary" class="primary-btn" disabled>Information Validated <span class='material-symbols-outlined success-green'>check_circle</span></button>
      </div>
    }
    @if (hasAttemptedValidation && !isValid) {
      <div class='form-group checkbox-container'>
        <div>
          <span class='material-symbols-outlined checkbox-warning'>warning</span>
        </div>
        <mat-checkbox class="compare-plan-checkbox" (change)="checkboxChecked($event)">
          <p>Please check the box if you would like to proceed without correcting your information.
          Please be advised there may be a delay in processing your application if there are any inaccuracies.</p>
        </mat-checkbox>
      </div>
    }
    @if (hasAttemptedValidation && !isValid && !isCheckboxChecked) {
      <mat-error>Box must be checked to proceed.</mat-error>
    }
  </div>
}